// src/pages/Solutions.js
import Header from '../components/Header';
import Footer from '../components/Footer';
import BookSection from "../components/BookSection"

const Book = () => {
  return (
    <div>
      <Header />
      <BookSection/>
      <Footer/>
    </div>
  );
};

export default Book;
